<div 
  class="spinner-container"
  [style.--spinner-margin-top]="spinnerMarginTop()">
  <div
    class="spinner"
    [style.--spinner-width]="spinnerWidth()"
    [style.--spinner-color]="spinnerColor()">
  </div>
  @if (text()) {
  <p class="spinner-text"
      [style.--spinner-font-size]="spinnerFontSize()"
    >{{ text() }}</p>
  }
</div>
